import { render, staticRenderFns } from "./HomeSection.vue?vue&type=template&id=124b42bc&scoped=true"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"
import style0 from "./HomeSection.vue?vue&type=style&index=0&id=124b42bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b42bc",
  null
  
)

export default component.exports